/* src/components/menu/menu.component.scss */
.company-type-management-header {
  margin-top: var(--vwui-size-spacing-lg);
}
.company-type-selection {
  margin: var(--vwui-size-spacing-xs) var(--vwui-size-spacing-lg);
}
/*# sourceMappingURL=menu.component-G6EQZVQL.css.map */
